module.exports = __webpack_public_path__ + "static/media/freqAskQues.829cfdfa.png";